import { DeviceSelection } from "@/interfaces/devices/selection";

export interface DeviceIds {
  audioInput: string;
  audioOutput: string;
  videoInput: string;
  videoQuality: string;
}

const DevicesStorageKey = "DEVICES";
export const storeDevices = async (devices: DeviceSelection): Promise<void> => {
  console.log(devices);
  localStorage.setItem(
    DevicesStorageKey,
    JSON.stringify({
      audioInput: devices.audioInput?.deviceId,
      audioOutput: devices.audioOutput?.deviceId,
      videoInput: devices.videoInput?.deviceId,
      videoQuality: devices.videoQuality
    })
  );
  return Promise.resolve();
};

export const loadDevices = async (): Promise<DeviceIds> => {
  const devices = JSON.parse(localStorage.getItem(DevicesStorageKey) || "{}");
  return Promise.resolve(devices);
};
